import { callApi } from '@local_modules/generic/fetch'
import { fillString } from '@local_modules/generic/string-template'

export async function disconnectTenant (xeroTokenId, xeroConnectionId) {
  const urlEndpoint = '/api/connect-xero/:xeroTokenId/:xeroConnectionId/disconnect'

  const url = fillString(urlEndpoint, {
    xeroTokenId,
    xeroConnectionId
  })

  const response = await callApi(url, null, {
    method: 'DELETE'
  })

  return response
}
